export const VIDEO_DOCUMENT_ID_PLACEHOLDER = "00000000-0000-0000-0000-000000000000";

type DataRoomItem = {
  documentId?: string;
  videoId?: string | null;
};

function resolveVideoId(doc: DataRoomItem, videoIdByDocumentId?: Record<string, string>): string | undefined {
  const videoId = doc.videoId?.trim();

  if (videoId) return videoId;

  const documentId = String(doc.documentId ?? "").trim();

  if (documentId && documentId !== VIDEO_DOCUMENT_ID_PLACEHOLDER) {
    return videoIdByDocumentId?.[documentId];
  }

  return undefined;
}

export function getDataRoomItemKey(doc: DataRoomItem, videoIdByDocumentId?: Record<string, string>): string {
  const videoId = resolveVideoId(doc, videoIdByDocumentId);

  if (videoId) return `video:${videoId}`;

  const documentId = String(doc.documentId ?? "").trim();

  if (!documentId) {
    console.warn("DataRoom item missing documentId and videoId", doc);

    return "doc:__missing__";
  }

  return `doc:${documentId}`;
}

export function parseDataRoomItemKey(itemKey: string): { documentId: string; videoId?: string } {
  if (itemKey.startsWith("video:")) {
    const videoId = itemKey.slice(6);

    return { videoId, documentId: "" };
  }

  if (itemKey.startsWith("doc:")) {
    return { documentId: itemKey.slice(4) };
  }

  return { documentId: itemKey };
}

export function buildVideoIdByDocumentId(
  documents: Array<{ documentId?: string; videoId?: string | null }>
): Record<string, string> {
  const map: Record<string, string> = {};

  for (const doc of documents) {
    const videoId = doc.videoId?.trim();
    const documentId = String(doc.documentId ?? "").trim();

    if (!videoId || !documentId || documentId === VIDEO_DOCUMENT_ID_PLACEHOLDER) continue;

    map[documentId] = videoId;
  }

  return map;
}
